
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.16 12.788l-.96-7.66a1.002 1.002 0 111.99-.25l.99 7.91H32c1.031-4.293 4.125-6.18 6.782-6.51a.987.987 0 011.11.87c.103.847.212 3.335-1.587 5.64h1.536c.27 0 .53.11.72.3.19.19.29.46.28.73l-.11 3.685c.003.045.001.091-.003.136l-.377 12.64c-.01.25-.11.5-.29.68-.642.641-1.021 1.268-1.096 2.56a4.322 4.322 0 01.007.25 1.008 1.008 0 01-.02.197v.072l-.49 20.07c-.01.55-.45.98-1 .98H22.38c-.54 0-.99-.43-1-.98l-.49-20.07-.001-.135a.984.984 0 01-.01-.135l.002-.13c-.06-1.378-.442-2.02-1.101-2.68a.96.96 0 01-.29-.68l-.337-11.327a.988.988 0 01-.012-.372l-.141-4.76c-.01-.27.09-.53.28-.73.19-.19.45-.3.72-.3h2.158zm-1.13 2.01h17.78l-.062 2.086c-1.283.399-4.503.74-9.177-.146-2.497-.47-5.515-.236-8.463.63l-.077-2.57zm14.434-2.01c1.846-1.39 2.35-3.104 2.457-4.27-1.264.427-3.05 1.52-3.858 4.27h1.401zm2.897 17.05a5.828 5.828 0 00-.582.768 5.066 5.066 0 00-3.828-1.728c-1.647 0-3.11.774-4.025 1.969a5.059 5.059 0 00-4.025-1.969c-1.535 0-2.91.672-3.83 1.73a5.52 5.52 0 00-.59-.77l-.312-10.405c2.786-.895 5.741-1.169 8.032-.735 4.134.78 7.464.716 9.485.264l-.325 10.876zm-9.438 4.001c.002.024.004.047.008.07v19.18h-5.57l-.47-19.07a10.375 10.375 0 00-.007-.389c.075-1.526 1.395-2.752 3.017-2.752 1.67 0 3.02 1.3 3.02 2.89 0 .024 0 .048.002.071zm7.568 19.25h-5.56v-19.32c0-1.59 1.35-2.89 3.02-2.89 1.587 0 2.886 1.165 3.01 2.655-.007.152-.01.31-.01.474l-.46 19.08z"}})])
          )
        }
      }
    